import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_2 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_3 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_4 = { class: "flex space-x-3" }
const _hoisted_5 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_6 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_7 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_8 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_9 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_10 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_11 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_12 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_13 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_14 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_15 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_16 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_17 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_18 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }
const _hoisted_19 = { class: "col-span-12 lg:col-span-4 md:col-span-6" }

import PageLoader from "@/components/loaders/PageLoader.vue"
import IntakeLayout from '../../Component/IntakeLayout.vue';
import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from "vue-router";

import PersonalInformationService from "@/classes/Cases/IntakeForms/PersonalInformationService";
import { OptionInterface } from '@/interfaces/OptionInterface';
import { IntakeCaseInformation } from '@/interfaces/Cases/Intake';

import { errorResponse } from "@/helpers/errorMessage";
import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'
import { onIonViewWillEnter } from "@ionic/vue";

/**************************************** For Offline Imports */
import IntakePersonalInformationService from "@/classes/Cases/Intake/PersonalInformation/PersonalInformationService";
import Rules from "@/classes/Cases/Intake/PersonalInformation/Validation/Rules";
import { useNetworkStore } from "@/store/network"; 
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core";   
 import IntakePersonnalInfoOfflineProcessor from "@/classes/Cases/Intake/PersonalInformation/Processor/OfflineProcessor";
 import OnlineSynching from "@/classes/Synching/OnlineSynching";
 
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const { createRules } = Rules;
const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable); 
/**************************************** For Offline Imports */
const router = useRouter();
const route = useRoute();
const loading = ref(false);
const loaded = ref(false);
const showSuccess = ref(false);
const route_params = route.params;
const errors = ref<any>();
const patient = ref<string>('');
const isDirty = ref<boolean>(false)
const onlineSync = new OnlineSynching();

const form = ref({
    id: null, //TODO Should test on online
    legal_status: null,
    housing_classification_id: null,
    socio_economic_status_id: null,
    no_children_in_family: null,
    no_household_members: null,
    no_family_in_household: null,
    date_initiated: null,
})

const casesInformation = ref<IntakeCaseInformation>({
    last_name: '',
    first_name: '',
    gender: '',
    sex_at_birth: '',
    birthday_type: 0,
    date_initiated: '',
    birthdate: '',
    calculated_year: '',
    calculated_month: '',
    approximate_age: '',
    case_number: '',
    primary_diagnosis: '',
    social_worker: '',
    services_sought: '',
    informant_relation_child: '',
    other_relationship: '',
    external_referral_from: '',
    intra_referral_from: '',
    if_ward_referred: '',
    patient_id: 0,
    case_id: 0,
})

const housingClassifications = ref<OptionInterface[]>([])
const socioEconomics = ref<OptionInterface[]>([])
const legalStatus = ref<OptionInterface[]>([])
const patientId = computed(() => route_params?.patient);
const caseId = computed(() => route_params?.case);
const isIonWillEnter = ref<boolean>(false);


 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
    console.log(form.value);
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();
	result
		.then((res) => {
			if(res) { 
				save()
                errors.value = null; //clear errors upon success
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		})
 }

const fetch = async (): Promise<any> => {
    loading.value = true;
 
    await IntakePersonalInformationService
        .show(route_params?.patient, route_params?.case, isNetworkAvailable.value)
        .then(async ({data}) => {     
            housingClassifications.value = data.housingClassifications;
            socioEconomics.value = data.socioEconomics;
            legalStatus.value = data.legalStatus;
            patient.value = data.patient;
            
            Object.assign(form.value, data.item)
            if (isNetworkAvailable.value) {
                await IntakePersonnalInfoOfflineProcessor.syncToOffline(route_params?.case, form.value);
            }
            //TEST TO OFFLINE TOO MIGTH NOT WORKING ...DATA.ITEM.CASES_INFORMATION
            Object.assign(casesInformation.value,  data.item.cases_information)
        
            loading.value = false;
            loaded.value = true;
        })
        .catch(errors => {
            loading.value = false;
            console.log(errors)
        }) 

    loading.value = false;
    loaded.value = true;    
}

const save = async () => {
    loading.value = true;
    await IntakePersonalInformationService
    .update(form.value.id,route_params?.patient, route_params?.case, form.value, isNetworkAvailable.value)
    .then(({data}) => {
        console.log(data);
        loading.value = false;
        showSuccess.value = true;
        isDirty.value = false 
        if(isNetworkAvailable.value){
            setTimeout(() => {
                fetch();
                location.reload()
            }, 1000);
        }
    })
    .catch(error => {
        loading.value = false;
        errors.value = errorResponse(error.response?.data?.errors)
    }) 
    
}

const hasChange = () => {
    // isDirty.value = true
}

onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {
        await fetch();
        await onlineSync.checkDrafts();
    }
});

onMounted(async () => {
    await fetch();
    await onlineSync.checkDrafts();
    isIonWillEnter.value = true;
})


return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? (_openBlock(), _createBlock(IntakeLayout, {
        key: 0,
        patient: patient.value,
        isDirty: isDirty.value
      }, {
        actionButtons: _withCtx(() => [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/patient/${patientId.value}/cases/${caseId.value}/edit`))),
            customClass: "quinary md:w-auto w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }),
          _createVNode(ButtonComponent, {
            customClass: "primary md:w-auto w-full",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (validateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save Changes ")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TextInput, {
              label: "Last Name",
              placeholder: "Last Name",
              name: "last_name",
              id: "last_name",
              required: "",
              modelValue: casesInformation.value.last_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((casesInformation.value.last_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TextInput, {
              label: "First Name",
              placeholder: "First Name",
              name: "first_name",
              id: "first_name",
              required: "",
              modelValue: casesInformation.value.first_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((casesInformation.value.first_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TextInput, {
                label: "Sex",
                placeholder: "Sex",
                name: "Sex",
                id: "sex",
                required: "",
                modelValue: casesInformation.value.sex_at_birth,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((casesInformation.value.sex_at_birth) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createVNode(TextInput, {
                label: "Gender",
                placeholder: "Gender",
                name: "Gender",
                id: "gender",
                required: "",
                modelValue: casesInformation.value.gender,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((casesInformation.value.gender) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([
                casesInformation.value.birthday_type === 2 ? 'col-span-8':  
                casesInformation.value.birthday_type === 0 ? 'lg:col-span-4 md:col-span-6 col-span-12':  
                'col-span-7'
            ])
          }, [
            (!loading.value)
              ? (_openBlock(), _createBlock(DatePicker, {
                  key: 0,
                  id: "date_initiated",
                  name: "date_initiated_date_time",
                  label: "Date initiated",
                  required: "",
                  modelValue: form.value.date_initiated,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.date_initiated) = $event)),
                  error: errors.value?.date_initiated
                }, null, 8, ["modelValue", "error"]))
              : _createCommentVNode("", true)
          ], 2),
          (!loading.value)
            ? (_openBlock(), _createBlock(UserBirthdateAge, {
                key: 0,
                form: casesInformation.value,
                errors: errors.value,
                disabled: "",
                customClass: "lg:col-span-4 md:col-span-6 col-span-12"
              }, null, 8, ["form", "errors"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TextInput, {
              label: "Case Number",
              placeholder: "Case Number",
              name: "case_number",
              id: "case_number",
              modelValue: casesInformation.value.case_number,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((casesInformation.value.case_number) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TextInput, {
              label: "Primary Diagnosis",
              placeholder: "Primary Diagnosis",
              name: "primary_diagnosis",
              id: "primary_diagnosis",
              modelValue: casesInformation.value.primary_diagnosis,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((casesInformation.value.primary_diagnosis) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(TextInput, {
              label: "Informant relation to child",
              placeholder: "Informant relation to child",
              name: "informant_relation_child",
              id: "informant_relation_child",
              modelValue: casesInformation.value.informant_relation_child,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((casesInformation.value.informant_relation_child) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(TextInput, {
              label: "Other Relationship",
              placeholder: "Other Relationship",
              name: "other_relationship",
              id: "other_relationship",
              modelValue: casesInformation.value.other_relationship,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((casesInformation.value.other_relationship) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(TextInput, {
              label: "Services sought",
              placeholder: "Services sought",
              name: "services_sought",
              id: "services_sought",
              modelValue: casesInformation.value.services_sought,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((casesInformation.value.services_sought) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(TextInput, {
              label: "Social worker",
              placeholder: "Social worker",
              name: "social_worker",
              id: "social_worker",
              modelValue: casesInformation.value.social_worker,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((casesInformation.value.social_worker) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(TextInput, {
              label: "External referral from",
              placeholder: "External referral from",
              name: "external_referral_from",
              id: "external_referral_from",
              modelValue: casesInformation.value.external_referral_from,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((casesInformation.value.external_referral_from) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(TextInput, {
              label: "Intra-PGH referral from",
              placeholder: "Intra-PGH referral from",
              name: "intra_referral_from",
              id: "intra_referral_from",
              modelValue: casesInformation.value.intra_referral_from,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((casesInformation.value.intra_referral_from) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(TextInput, {
              label: " If inpatient, which ward referred",
              placeholder: "If inpatient, which ward referred",
              name: "if_ward_referred",
              id: "if_ward_referred",
              labelClass: "!text-neutral-400",
              modelValue: casesInformation.value.if_ward_referred,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((casesInformation.value.if_ward_referred) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(MultiSelect, {
              searchable: "",
              options: legalStatus.value,
              label: "Legal Status",
              id: "legal_status",
              name: "legal_status",
              placeholder: "Select..",
              modelValue: form.value.legal_status,
              "onUpdate:modelValue": [
                _cache[16] || (_cache[16] = ($event: any) => ((form.value.legal_status) = $event)),
                hasChange
              ],
              error: errors.value?.legal_status,
              required: ""
            }, null, 8, ["options", "modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(MultiSelect, {
              searchable: "",
              options: housingClassifications.value,
              label: "Housing Classification",
              id: "housing_classification_id",
              name: "housing_classification",
              placeholder: "Select..",
              modelValue: form.value.housing_classification_id,
              "onUpdate:modelValue": [
                _cache[17] || (_cache[17] = ($event: any) => ((form.value.housing_classification_id) = $event)),
                hasChange
              ],
              error: errors.value?.housing_classification_id,
              required: ""
            }, null, 8, ["options", "modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(MultiSelect, {
              searchable: "",
              options: socioEconomics.value,
              label: "Socio Economic Status",
              id: "socio_economic_status_id",
              name: "socio_economic_status",
              placeholder: "Select..",
              modelValue: form.value.socio_economic_status_id,
              "onUpdate:modelValue": [
                _cache[18] || (_cache[18] = ($event: any) => ((form.value.socio_economic_status_id) = $event)),
                hasChange
              ],
              error: errors.value?.socio_economic_status_id,
              required: ""
            }, null, 8, ["options", "modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(TextInput, {
              type: "number",
              label: "Number of Children in the Family",
              placeholder: "Number of Children in the Family",
              name: "number_children_family",
              id: "no_children_in_family",
              modelValue: form.value.no_children_in_family,
              "onUpdate:modelValue": [
                _cache[19] || (_cache[19] = ($event: any) => ((form.value.no_children_in_family) = $event)),
                hasChange
              ],
              error: errors.value?.no_children_in_family,
              required: ""
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(TextInput, {
              type: "number",
              label: "Number of Household Members",
              placeholder: "Number of Household Members",
              name: "number_household_members",
              id: "no_children_in_family",
              modelValue: form.value.no_household_members,
              "onUpdate:modelValue": [
                _cache[20] || (_cache[20] = ($event: any) => ((form.value.no_household_members) = $event)),
                hasChange
              ],
              error: errors.value?.no_household_members,
              required: ""
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(TextInput, {
              type: "number",
              label: "Number of Families in Household",
              placeholder: "Number of Families in Household",
              name: "number_families_household",
              id: "no_family_in_household",
              modelValue: form.value.no_family_in_household,
              "onUpdate:modelValue": [
                _cache[21] || (_cache[21] = ($event: any) => ((form.value.no_family_in_household) = $event)),
                hasChange
              ],
              error: errors.value?.no_family_in_household,
              required: ""
            }, null, 8, ["modelValue", "error"])
          ]),
          _createVNode(SuccessModal, {
            noBtn: "",
            show: showSuccess.value,
            "action-text": "Close",
            title: "Record Save",
            content: "Intake has been updated",
            onClose: _cache[22] || (_cache[22] = ($event: any) => (showSuccess.value = false))
          }, null, 8, ["show"]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      }, 8, ["patient", "isDirty"]))
    : _createCommentVNode("", true)
}
}

})